module.exports = __webpack_public_path__ + "img/orden.e470adc6.png";